module.exports = __webpack_public_path__ + "fonts/Helvetica-LT-95-Black.46685422.ttf";